var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_476_6603)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.0834C0 8.74664 2.70495 6.04169 6.04167 6.04169H22.9583C26.295 6.04169 29 8.74664 29 12.0834V16.9167C29 20.2534 26.295 22.9584 22.9583 22.9584H6.04167C2.70495 22.9584 0 20.2534 0 16.9167V12.0834ZM6.04167 8.45835C4.03964 8.45835 2.41667 10.0813 2.41667 12.0834V16.9167C2.41667 18.9188 4.03964 20.5417 6.04167 20.5417H22.9583C24.9604 20.5417 26.5833 18.9188 26.5833 16.9167V12.0834C26.5833 10.0813 24.9604 8.45835 22.9583 8.45835H6.04167ZM12.0833 13.2917C12.0833 11.957 13.1653 10.875 14.5 10.875C15.8347 10.875 16.9167 11.957 16.9167 13.2917V15.7084C16.9167 17.0431 15.8347 18.125 14.5 18.125C13.1653 18.125 12.0833 17.0431 12.0833 15.7084V13.2917ZM7.25 10.875C5.91531 10.875 4.83333 11.957 4.83333 13.2917V15.7084C4.83333 17.0431 5.91531 18.125 7.25 18.125C8.58469 18.125 9.66667 17.0431 9.66667 15.7084V13.2917C9.66667 11.957 8.58469 10.875 7.25 10.875Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_476_6603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking);
export default __webpack_public_path__ + "static/media/working.133797ab4984d5318d9cfcd28b2c61f3.svg";
export { ForwardRef as ReactComponent };